import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Typography, useTheme } from "@mui/material";
import InfoIcon from "@icons/myicons/info2.svg?react";

export const NoDataBlock = () => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Box display="flex" alignItems="center" justifyContent="center">
      <Typography
        variant="body3"
        color={theme.palette.text.disabled}
        display="flex"
        alignItems="center"
        gap={2}
      >
        <InfoIcon />
        {t("recommender.compareView.noData")}
      </Typography>
    </Box>
  );
};
